<template>
 <!--   -->
    <div class="class"
      @mouseleave="chlinLeave" 
    >
     <div class="item-all flex align-cen">
          <!-- <el-input
                placeholder="搜索产品"
                v-model="search">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input> -->
            <div class="all-text mft" style="" @click="chlinLeave">
                <i class="el-icon-close" style="font-weight:bold"></i>
            </div>
        </div>
        <div class="navitem flex">
            <div class="item-left" 
            >
             <div class="item-list"
            v-for="(item, index) in itemList"
            :key="index"
            :class="index == itemActive  ? 'item-active-color': ''"
            @click="typeIndex == 1 ? gethisList1(item.id,index,item.name): gethisList(item.id,index,item.name)"
             >
            <div class="type-title-cn">
                {{item.name}}
                 <div class="type-title-cn-border"></div>
            </div>
           
             </div>
            </div>
            <div class="item-right">
                <div class="right-data   flex align-cen"
                v-if="dataList.length && typeIndex == 2">
                    <div class="data-list   flex align-cen"
                     v-for="(item, index) in dataList"
                    :key="index"
                    @click="openView(item)"
                    >
                    <div class="text">{{item.name}}</div>
                    </div>
                </div>
             <div class="right-data1"
                 v-if="dataList1.length && typeIndex == 1"
                >
                <div class="app-itemlist"
                 v-for="(item, index) in dataList1"
                :key="item.id"
                >
                    <div class="app-title">
                        {{item.name}}
                    </div>
                    <div class="second-menu-item-content"
                      v-for="(k, index) in item.applicationVOList"
                        :key="k.id"
                        @click="openView(k)"
                    >
                        {{k.name}} 
                    </div>
                </div>
                </div>
                        </div>
        </div>
        <!-- {{index}} -->
    </div>
</template>
<script>
import { classList,ProductList,appTlist} from "@/api/enterprise/index" //分类，列表 、二级分类
export default {
    name:'classTem',
    props:{
        activeIndex: [String,Number], 
    },
    data() {
        return {
            search:'',
            typeIndex:1,
            itemList:[],
            itemActive:0,
            fristId:'',
            fristName:'',
            dataList:[],
            dataList1:[],
            rightName:''
        }
    },
    watch: {
     activeIndex: {
      handler (n, o) {
       this.typeIndex = n
        let that = this
        //    异步同步执行
            this.gethisInfo().then(function(){
            that.typeIndex == 1 ? that.gethisList1(that.fristId,0,that.fristName) : that.gethisList(that.fristId,0,that.fristName) 
            })
      },
      deep: true // 深度监听父组件传过来对象变化
    },
    },
    created () {
        let that = this
        this.typeIndex = this.activeIndex
           //    异步同步执行
            this.gethisInfo().then(function(){
            that.typeIndex == 1 ? that.gethisList1(that.fristId,0,that.fristName) : that.gethisList(that.fristId,0,that.fristName)            
            })
        
    },
    methods: {
                // 打开页面
    openView(data){
        this.$emit('sendStatus', this.typeIndex,true)
         if(this.typeIndex == 1){
            const newurl = this.$router.resolve({name: 'endowloadHlyhDetail', query: {id: data.id,type:2}})
             window.open(newurl.href,'_blank')
            }else if(this.typeIndex == 2){
              if(data.contentType == '2'){
                let path=data.content
               window.open(path,'_black')
             }else{
               const newurl = this.$router.resolve({name: 'enHlyhSolution', query: {id: data.id,type:2}})
               window.open(newurl.href,'_blank')
             }
            }else{

            }
    },
        // 打开页面
    // openView(data){
    //     this.$emit('sendStatus', this.typeIndex,true)
    //      const newurl = this.$router.resolve({name: this.typeIndex == 1 ? 'endowloadHlyhDetail' : 'enHlyhSolution', query: {id: data.id,type:2}})
    //      window.open(newurl.href,'_blank')
    // },
    // 子组件离开
    chlinLeave(){
        this.$emit('sendStatus', this.typeIndex)
    },
     async gethisInfo(){
            await classList({officialType:2},'enterprise',this.typeIndex)
            .then(res => {
             
               this.itemList = res.data
               this.fristId = res.data[0].id
               this.fristName = res.data[0].name
            })
            .catch(err => {
            })
        },
        gethisList(id,index,fristName){
            
            this.itemActive = index
            this.rightName = fristName
            ProductList({id:id,officialType:2},'enterprise',this.typeIndex)
            .then(res =>{
                this.dataList = res.data || []
            })
        },
        gethisList1(id,index,fristName){
             this.itemActive = index
            this.rightName = fristName
            appTlist({id:id,officialType:2},'enterprise')
            .then(res =>{
                this.dataList1 = res.data || []
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.class{
    background: #fff;
    position: absolute !important;
    color: #000;
    top: 64px;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
    width: 100%;
    left:0;
     max-height: 50vh;
    height: 50vh;
     background: #fff;
    .item-all{
        background: #f5f5f6;
        height: 60px;
        line-height: 60px;
        padding: 0 20px;
        .el-input {
            width: 200px;
            .el-input__inner{
                border: none;
            }
        }
        .all-text{
            font-weight: 700;
    color: #181818;
    font-size: 14px;
    cursor: pointer;
    padding-left: 20px;
        }
    }
    .navitem{
        height: calc(100% - 100px);
        overflow: auto;
    position: relative;
    overflow: hidden;
    padding: 20px;
    margin: 0 auto;
    width: calc(100% - 100px);
    }
    .item-left{
        border-right: 1px solid rgba(61,61,61,.15);
     height: 100%;
       width: 220px;
            overflow: auto;
       .item-list{
         height: 36px;
         line-height: 36px;
         cursor: pointer;
       }
       .type-title-cn{
         display: inline-block;
         position: relative;
       }
        .type-title-cn:hover{
            color: #2893f1;
        }
       .type-title-cn-border{
        width: 100%;
        bottom: 4px;
        position: absolute;
        border-bottom: 2px solid #2893f1;
        padding-bottom: 6px;
        transform: scaleX(0);
        transform-origin: left;
        transition: transform .15s ease-in-out;
       }
       .item-active-color{
            color: #2893f1;
            position: relative;
            background: #fff;
            position: relative;
            .type-title-cn-border{
                transform: scaleX(1);
            }
         }
         
        //  .item-active-color::before{
        //     content: '';
        //     height: 2px;
        //     width: 80px;
        //     background:#2893f1;
        //     position: absolute;
        //     bottom: -2px;
        //     left: 0px;
        //  }
    //    .item-list:last-child{
    //     // padding-bottom: 20px;
    //    }
    }
    .item-right{
        height: 100%;
        width: calc(100% - 288px);
        padding-left: 48px;
        background: #fff;
        overflow-x:hidden ;
        overflow-y: auto;
        .tit-img {
            img{
                width: 120px;
                margin-top: -5px;
            }
            .line{
                width: 2px;
                height: 30px;
                margin: 0 20px;
                background: #323233;
            }
            p{
                color: #323233;
                font-size: 18px;
                
            }
            padding: 20px 30px;
        }
        .right-data{
            padding: 0 20px;
            padding-bottom: 20px;
            flex-wrap: wrap;
            align-content: space-between;
            .data-list{
             width: 25%;
                height: 35px;
            line-height: 35px;
            text-align: center;
            font-size: 13px;
            color: #181818;
             text-decoration: none;
             cursor: pointer;
                img{
                    width: 40px;
                    height: 40px;
                }
                .text{
                    padding-left: 10px;
                    
                }
            }
            .data-list:hover{
                  color: #2893f1;
            }
        }
        .right-data1{
            column-count: 4;
            -webkit-column-count:4;
            -moz-column-count: 4;
            column-gap: var(--nav-grid-column-gap);
            -webkit-column-gap: var(--nav-grid-column-gap);
            -moz-column-gap: var(--nav-grid-column-gap);
            // padding: 0 20px;
            // padding-bottom: 20px;
            // flex-wrap: wrap;
            // width: 100%;
            .app-itemlist{
                display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            break-inside: avoid;
            //   width: 264px;
            //   margin-bottom: 30px;
              .app-title{
                 color: #2893f1;
                line-height: 14px;
                margin-top: 10px;
                margin-bottom: 10px;
                font-weight: 600;
              }
              .second-menu-item-content{
                cursor: pointer;
                    text-align: left;
                line-height: 23px;
                font-size: 13px;
                color: #181818;
                text-decoration: none;
                padding: 4px 0 4px 0px;
              }
               .second-menu-item-content:hover{
                  color: #2893f1;
               }
            }
        }
    }
         /*滚动条样式*/
        .item-right::-webkit-scrollbar {
            width: 4px;    
        }
        .item-right::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
            background: rgba(0,0,0,0.2);
        }
        .item-right::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
            border-radius: 0;
            background: rgba(255,255,255,0.1);

        }
           /*滚动条样式*/
        .item-left::-webkit-scrollbar {
            width: 4px;    
        }
       .item-left::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
            background: rgba(0,0,0,0.2);
        }
        .item-left::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
            border-radius: 0;
            background: rgba(255,255,255,0.1);

        }
    .endowloadDetail-contaniner1{
        padding: 50px 0 !important;
        background: #fff;
    }
}
// @media only screen and (min-width: 1680px){
//    .navitem{
//     width: 1440px;
//    } 
// }
// @media only screen and (max-width: 1680px){
//      .navitem{
//     width: 1200px;
//    } 
//     .app-itemlist{
//               width: 230px;
//     }
// }
::v-deep{
      .el-input {
        .el-input__inner{
        height: 35px;
        background: #fff;
        border: none;
        border-radius: 2px;
        color: #000;
        }
        i{
            color: #00AFFF;
        }
}
}
</style>